import React from 'react';

import { CACHE_TYPE, cache } from '@lumapps/cache';
import { customerIdSelector } from '@lumapps/customer/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

const INSTANCE_SWITCHER_REDIRECT = 'site-switcher-redirect';

const createCacheKey = (customerId: string) => `${customerId}-${INSTANCE_SWITCHER_REDIRECT}`;

export const useInstanceSwitcherRedirect = () => {
    const customerId = useSelector(customerIdSelector);
    const cacheKey = createCacheKey(customerId);

    const shouldRedirectFromSiteSwitcher = cache.retrieve(cacheKey, CACHE_TYPE.STORAGE) === '1';
    const { translateKey } = useTranslate();

    const clear = React.useCallback(() => cache.remove(cacheKey, CACHE_TYPE.STORAGE), [cacheKey]);
    const set = React.useCallback(() => cache.store(cacheKey, '1', CACHE_TYPE.STORAGE), [cacheKey]);

    return {
        clear,
        set,
        shouldRedirectFromSiteSwitcher,
        errorDescription: translateKey(GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_DESCRIPTION),
        errorTitle: translateKey(GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_TITLE),
    };
};
